export default "__VITE_ASSET__Cgyu8jY2__"